import { TimeFormat } from "./types";
import IconAccessTime from "@servicetitan/hammer-icon/mdi/round/access_time.svg";

// Time Constants
export const TIME_CONSTANTS = {
  /** Minutes in a full day (24 hours * 60 minutes) */
  MINUTES_IN_DAY: 1440,
  /** Maximum hour in 24-hour format */
  MAX_HOUR_24: 23,
  /** Maximum minute value */
  MAX_MINUTE: 59,
  /** Timeout in milliseconds for input debouncing */
  INPUT_DEBOUNCE_TIMEOUT: 100,
} as const;

// Format Constants
export const FORMAT_CONSTANTS = {
  /** 12-hour time format */
  TWELVE_HOUR: 12 as const,
  /** 24-hour time format */
  TWENTY_FOUR_HOUR: 24 as const,
} as const;

/**
 * Placeholder strings for different time formats.
 */
export const TIME_FORMAT_PLACEHOLDERS: Record<TimeFormat, string> = {
  12: "––:–– ––",
  24: "––:––",
};

/**
 * Clock icon used as prefix in the time input field.
 */
export const CLOCK_ICON = IconAccessTime;
